import { render } from "./HouseParts.vue?vue&type=template&id=093baf06&scoped=true&lang=pug"
const script = {}

import "./HouseParts.vue?vue&type=style&index=0&id=093baf06&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-093baf06"]])

export default __exports__